import React from "react";
import Layout from "../layout/layout";
import Write from "../views/home/write";

const GetSetups = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <Layout>
        <div className="max-w-[1300px] w-full">
          <Write isGetSetups={true} />
        </div>
      </Layout>
    </div>
  );
};

export default GetSetups;
